import jQuery from 'jquery';
import select2 from 'select2';
import 'select2/dist/css/select2.min.css';

window.$ = window.jQuery = jQuery;
select2($);
